import { ISelectValue } from 'constants/globalTypes'

export const workKindOptions: ISelectValue[] = [
  { value: 1, label: 'Repeating cycle (e.g. haul loop)' },
  { value: 2, label: 'Step-by-step job (e.g. construction)' },
  { value: 3, label: 'Single process' },
]

export const workKindShortOptions: ISelectValue[] = [
  { value: 1, label: 'Repeating cycle' },
  { value: 2, label: 'Step-by-step job' },
  { value: 3, label: 'Single process' },
]

export const nextPhaseStartOptions: ISelectValue[] = [
  { value: 1, label: 'When I say go' },
  { value: 2, label: 'As soon as this phase finishes' },
]

export const cantKeepUpOptions: ISelectValue[] = [
  { value: 1, label: 'Pause this work' },
  { value: 2, label: 'Do fewer at once' },
  { value: 3, label: 'Skip it this round' },
  { value: 4, label: 'Just warn me' },
]

export const workAheadOptions: ISelectValue[] = [
  { value: 1, label: 'A few hours ahead' },
  { value: 2, label: 'One shift ahead' },
]

export const findWording = (options: ISelectValue[], value?: number) =>
  options.find((o) => o.value === value)?.label

export const phaseStartWording = (value?: number) =>
  value === 1
    ? 'starts when I say go'
    : value === 2
    ? 'starts as soon as the previous phase finishes'
    : ''
